
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getLocalizedTaxName, getDisplayOrderNumber, getOrderType } from '@/utils/getters';

const namespace: string = 'auth';

// If modifying this component, review whether similar updates are required in the OrdersReport component and its children.
@Component<ChitPrint>({})
export default class ChitPrint extends Vue {
	@Getter('getRestaurant', { namespace }) private restaurant!: Restaurant;
	@Getter('getTimezone', { namespace }) private timezone!: string;
	@Getter('isTaxInclusiveWithInfo', { namespace }) private isTaxInclusiveWithInfo!: boolean;
	@Prop({ type: Object, default: () => {} }) private formattedDates!: { startDate: string, endDate: string, date: string };
	@Prop({ type: Array, default: () => [] }) private sortedOrders!: EventSuiteOrder[];
	@Prop({ type: Array, default: () => [] }) private groupedItems!: OrderItemGroup[];
	@Prop({ type: Boolean, default: false }) private includePrices!: boolean;

	/**
	 * Get the title of the order chit: either student name or contact name.
	 *
	 * @param {EventSuiteOrder} order
	 * @return {string}
	 */
	private getOrderTitle(order: EventSuiteOrder): string {
		return order.data.checkout.delivery?.student || order.data.checkout.contact?.full_name;
	}

	private getOrderCosts(order: EventSuiteOrder): OrderCostsSimplified {
		return order.data.costs;
	}

	/**
	 * Get the order number to display, prefixed with the restaurant's internal identifier.
	 *
	 * @param {EventSuiteOrder} order
	 * @return {string}
	 */
	private getOrderNumber(order: EventSuiteOrder): string {
		return getDisplayOrderNumber(order.id);
	}

	/**
	 * Get the order type key used for the chit's type label.
	 *
	 * @param {EventSuiteOrder} order
	 * @return {string}
	 */
	private getOrderType(order: EventSuiteOrder): string {
		return getOrderType(order).type;
	}

	/**
	 * Get the localized name of the tax if possible.
	 *
	 * @param {string} taxName
	 * @return {string}
	 */
	private getLocalizedTaxName(taxName: string): string {
		return getLocalizedTaxName(taxName, this.restaurant);
	}
}
